import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="h-[80vh] flex items-center justify-center bg-lightBeige px-4">
      <div className="text-center max-w-xl mx-auto">
        <h1 className="text-9xl font-bold text-primaryDark mb-4">
          {t("notFound.title")}
        </h1>
        <div className="h-2 w-24 bg-primary mx-auto mb-8 rounded-full"></div>
        <h2 className="text-2xl md:text-3xl font-semibold text-dark mb-4">
          {t("notFound.heading")}
        </h2>
        <p className="text-gray-600 mb-8">{t("notFound.message")}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary hover:bg-primaryDark text-dark font-medium rounded-lg transition-all duration-300"
        >
          <ArrowLeft size={20} weight="bold" />
          {t("notFound.backToHome")}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
